import React from 'react';
import ReactLoader from 'react-loading';

import Toggle from 'components/Toggle';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { CostCenter } from 'models/costCenter';

import { Container, Content, Header, Switch, ArrowIcon, ToggleLoader, ToggleContainer } from './styles';

interface Props {
  costCenter: CostCenter;
  onClick: () => void;
  onToggle?: () => void;
  loading?: boolean;
}

const CostCenterItem = ({ costCenter, onClick, onToggle, loading }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Container>
      <Switch>
        {loading ? (
          <ToggleContainer>
            <ToggleLoader>
              <ReactLoader type="bubbles" color="#C3C2C2" width={30} height={30} />
            </ToggleLoader>
            <Toggle onChange={onToggle} checked={costCenter.isActive} disabled={true} />
          </ToggleContainer>
        ) : (
          <Toggle onChange={onToggle} checked={costCenter.isActive} />
        )}
      </Switch>
      <Content onClick={onClick}>
        <Header>
          <Header.Title>{costCenter.name}</Header.Title>
          <Header.Text>{t('costCenter.costCenterAggregation.code', { code: costCenter.code })}</Header.Text>
        </Header>
        <ArrowIcon />
      </Content>
    </Container>
  );
};

export default CostCenterItem;
